<div id="background-check" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2 bg-white">
    <div class="flex flex-col sm:w-auto md:hidden p-8">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Personal Information</h2>
              <p>Driver’s license, social security, marital status, children and pets</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/personal" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Residency History</h2>
              <p>Two years of residency history information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/residency" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Employment Information</h2>
              <p>Two years of employment information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/employment" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div *ngIf="verifastEnabled" class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Income & Identity</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/verifast" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">6/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Verify Income</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/documents" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">6/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">7/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Background Check</h2>
              <p>You have agreed to the Terms and Conditions</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/background-check" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">7/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">8/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Additional Applicants</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-righ"
                routerLink="/application/applicants" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div *ngIf="hasRentableItems" class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">8/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">9/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Rentable Items and Services</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/rentables" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">{{8 + appStepIncrement}}/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Payment Information</h2>
          </div>
        </div>
      </div>
      <div class="pt-2">
        <div
          *ngIf="modelApplicationInvites.AllInvitesComplete==false && modelApplicationFee.AllApplicantsComplete==true"
          class="alert alert-danger payment-conditional-alert">
          <p>Not all the invitations to your application have been accepted. All invitations must be accepted before
            submitting the application. If you pay now, {{incompleteInvitesWarningMessageNames}} will be removed.</p>
          <p>Please <a routerLink="/application/applicant" routerLinkActive="active">click here</a> to resend
            invitations.</p>
        </div>
        <div
          *ngIf="modelApplicationFee.AllApplicantsComplete==false && modelApplicationInvites.AllInvitesComplete==true"
          class="alert alert-danger payment-conditional-alert">
          <p>Not all the applicants on your application have completed the application. All applicants must be completed
            before submitting the application. If you pay now, {{incompleteApplicantWarningMessageNames}} will be
            removed.</p>
          <p>Please <a routerLink="/application/applicant" routerLinkActive="active">click here</a> to resend
            invitations.</p>
        </div>
        <div
          *ngIf="modelApplicationFee.AllApplicantsComplete==false && modelApplicationInvites.AllInvitesComplete==false"
          class="alert alert-danger payment-conditional-alert">
          <p>Not all the applicants on your application have completed the application and not all invitations have been
            accepted. All applicants must be completed and all invitations must be accepted before submitting the
            application. If you pay now the incomplete applicants, {{incompleteApplicantWarningMessageNames}} will be
            removed along with the unaccepted invitations to, {{incompleteInvitesWarningMessageNames}}.</p>
          <p>Please <a routerLink="/application/applicant" routerLinkActive="active">click here</a> to resend
            invitations.</p>
        </div>
        <div
          *ngIf="modelApplicationInvites.ApplicantsWithMissingContactInformation.length > 0"
          class="alert alert-danger payment-conditional-alert">
          <p>
            Not all applicants have the required contact information: Email, Home Phone, and Cell Phone.
            These applicants were not properly notified. You need to complete the contact details, in order to
            properly invite them.
          </p>
          <p>
            Here are the applicants that are missing the required contact information:
          </p>
          <ol class="list-decimal ml-4 mt-2">
            <li *ngFor="let info of modelApplicationInvites.ApplicantsWithMissingContactInformation">
              {{info.FirstName}} {{info.LastName}}: {{info.MissingInfoDetails.join(', ')}}.
            </li>
          </ol>
          <p>
            Please <a routerLink="/application/applicants" routerLinkActive="active">click here</a> to resend
            invitations.
          </p>
        </div>
        <div *ngIf="coupon.Valid == false && coupon.ErrorText != '' && coupon.ErrorText != null"
          class="alert alert-danger payment-conditional-alert">
          <p>{{coupon.ErrorText}}</p>
        </div>
        <div *ngIf="coupon.Valid == true && coupon.SuccessText != '' && coupon.SuccessText != null"
          class="alert alert-success payment-conditional-alert">
          <p>{{coupon.SuccessText}}</p>
        </div>
        <p>A non-refundable application fee of ${{modelApplicationFee.ApplicantFee}} per applicant is required to
          process all applications. All applications are charged a ${{modelApplicationFee.ApplicationFee}} holding fee.
        </p>
        <div class="mt-4 px-4">
          <ul class="list-disc">
            <li>If you are approved and move in, the ${{modelApplicationFee.ApplicationFee}} holding fee will be applied
              to your first month’s rent.</li>
            <li>If you are approved and do not move in, you will forfeit the ${{modelApplicationFee.ApplicationFee}}
              holding fee.</li>
            <li>If you are denied, you will be refunded the ${{modelApplicationFee.ApplicationFee}} holding fee.</li>
            <li>The application fee of ${{modelApplicationFee.ApplicantFee}} per applicant will not be refunded.</li>
            <li>Before submitting payment, make sure all applicants are included. Once you pay, you will not be able to
              make changes and may need to reapply and pay the fees again to add additional people.</li>
            <li>Please ensure that your credit profile is unlocked with the credit rating agencies.</li>
            <li>Leases must be signed within 48 hours of receipt to avoid cancellation.</li>
            <li>Security deposit is due 48 hours after lease signing.</li>
          </ul>
        </div>
        <div *ngIf="modelProperty.state === 'CA'" class="mt-6">
          <h3 class="font-bold mb-2">Itemized Receipt of Application Charges:</h3>
          <ul class="list-disc ml-4">
            <li>Hard Costs: $20.45</li>
            <li>Processing Costs (Overhead): $75.97</li>
            <li>Total: $96.42</li>
            <li><strong>Discounted Amount Charged: $55</strong></li>
          </ul>
        </div>
        <div *ngIf="modelApplicationFee.DisplayMessage" class="payment-conditional-fee">
          <p style="font-size: 13px">{{modelApplicationFee.DisplayMessage}}</p>
        </div>
        <div *ngIf="modelApplicationFee.WaivingFee" class="payment-conditional-fee">
          <p class="text-danger"><strong>- ${{modelApplicationFee.AmountWaived}}</strong></p>
          <p><strong>Your New Total: ${{modelApplicationFee.TotalApplicationFee}}</strong></p>
        </div>
        <div *ngIf="!modelApplicationFee.WaivingFee" class="text-center pt-4 payment-conditional-fee">
          <p class="font-bold">Your total fee is: ${{modelApplicationFee.TotalApplicationFee}}</p>
        </div>
        <div *ngIf="monthlyRentWarningMessage" class="payment-conditional-fee">
          <p class="text-danger"><strong>{{monthlyRentWarningMessage}}</strong></p>
        </div>
        <div *ngIf="errorMessage!=null" class="alert alert-danger payment-conditional-alert">
          {{ errorMessage }}
        </div>
        <form *ngIf="!paymentProcessing" #couponForm="ngForm" class="mt-4 payment-conditional-form">
          <div class="md:flex items-top  justify-center">
            <div class="md:pr-2">
              <mat-form-field class="w-full my-2">
                <mat-label>Apply Coupon</mat-label>
                <input matInput name="CouponCode" id="CouponCode" [(ngModel)]="couponCode" #CouponCode="ngModel">
                <i *ngIf="coupon.Valid == true" class="material-icons coupSuccess">check_circle_outline</i>
                <i *ngIf="coupon.Valid == false && coupon.ErrorText != '' && coupon.ErrorText != null"
                  class="material-icons coupFail">clear</i>
              </mat-form-field>
            </div>
            <div class="text-right md:mt-2">
              <button mat-flat-button color="primary" id="SubmitCoupon" [disabled]="coupon.Valid"
                (click)="applyCoupon()">APPLY</button>
            </div>
          </div>
        </form>
        <form #paymentForm="ngForm">
          <div class="text-right py-4" *ngIf="hidePayment==false">
            <button *ngIf="!paymentProcessing" mat-flat-button color="primary" id="SubmitPayment"
              [disabled]="!paymentForm.form.valid || backgroundCheckNotVerified || modelApplicationInvites.ApplicantsWithMissingContactInformation.length > 0" (click)="startCheckout()">SUBMIT
              PAYMENT</button>
            <div *ngIf="paymentProcessing"
              class="grid grid-rows-2 justify-center justify-items-center gap-2 items-center mt-8 text-center">
              <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>Please wait while we process your
              payment.
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
